




// Scroll to top for  section "Custom FAQ"
$(document).ready(function () {
$('.back-to-top').click(function (){
    $('html, body ').animate({
      scrollTop: $("div.section__color-wrapper").offset().top
    }, 1000)
  })
});


$(document).ready(function() {


  
  var locations_map = {
    "300": "Vantaa, Petikko",
    "310": "Helsinki, Erottaja",
    "330": "Vantaa, Porttipuisto",
    "340": "Hyvinkää",
    "350": "Lahti",
    "360": "Lempäälä, Ideapark",
    "370": "Raisio",
    "380": "Jyväskylä",
    "390": "Kuopio",
    "400": "Seinäjoki",
    "410": "Espoo, Finnoo",
  };
  
variant_changed($('[name="id"]', 'form.shopify-product-form').val());  
  
  /**
   * Nayta varaamyymälästä lomake.
   * Hakee varastosaldot ensimmääisen näyttämisen yhteydessä.
   * 
   * @since 2021-06-21
   */
  $('.varaa-myymalasta-button').on('click', function() {
    var variant_id = $(this).data('variant-id');
    var skus = '';
    var cartitems = [];
    
    var wrapper = $('.varaa-myymalasta-wrapper');
    
    $('.varaa-myymalasta-products-available', wrapper).hide();
    $('.varaa-myymalasta-products-available .location', wrapper).hide();
    $('[name="contact[store]"]', wrapper).val('');
    
    $('.close', wrapper).on('click', function() {
      wrapper.removeClass('open');
    });
    
    $.each($.parseJSON($('#varaa-myymalasta-cart-items').html()), function() {
      if (skus) {
      	skus += ',';
      }
      skus += this.sku;
      
      cartitems[this.sku] = {
        title: this.title,
        quantity: this.quantity,
      };
      
      $('<input/>')
        .attr('type', 'hidden')
        .attr('name', 'contact[' + this.title + ']')
        .val(this.quantity + 'kpl')
      	.prependTo($('form', wrapper));
    });
    
    $('[name="contact[store]"]', wrapper).change(function() {
        $('.locations', wrapper).hide();
        $('.locations.location-'+ $(this).find(":selected").data('id'), wrapper).show();
      
        $('.varaa-myymalasta-products-available', wrapper).show();
    });
    
    wrapper.toggleClass('open');
    
    if (!wrapper.hasClass('fetched')) {
      stock_available(skus, function(products) {
      	if (products) {
            $.each(products, function(sku, locations) {
              if (cartitems[sku]) {
                var product_available = $('<div/>');

                if (locations) {
                  $.each(locations, function() {
                    if (locations_map[this.location] != undefined) {
                        var available = parseInt(this.instock) - cartitems[sku].quantity;
                    	product_available
                        	.append(
                            	$('<div>')
                              		.addClass('locations location-' + this.location)
                              		.append(
                                  		$('<span>')
                                  			.addClass('name')
                                  			.html(cartitems[sku].quantity + " x " + cartitems[sku].title)
                              		)
                        	  		.append(
                              			$('<span/>')
                                			.addClass('availability ' + (available > 4 && available < 10 ? 'available' : available > 10 ? 'available' : 'out-of-stock'))
                                			.html(available > 4 && available < 10 ? 'Saatavilla ' + available + " kpl"  :  available > 10  ? 'Saatavilla ' + "10+ kpl" : 'varmista myymälästä'  )
                              		)
                              		.hide()
                        	);
                    }
                  });
                }

                product_available.appendTo(
                  $('.varaa-myymalasta-products-available', wrapper)
                );
              }
              
            });
        }
      });
      
      wrapper.addClass('fetched');
    }
  });
  
  
   /**
   * Nayta myymäläsaldot tuotesivulla
   * Hakee varastosaldot ensimmäisen näyttämisen yhteydessä.
   * 
   * @since 2022-01-13
   */
  $('.product-tabs__trust-title.change_btn').on( 'click', function() {
    
    var skus = $(this).data('sku');
    
    var wrapper = $('.change-store');
     
    if (!wrapper.hasClass('fetched')) {
      stock_available(skus, function(products) {
      	if (products) {
           $('.instock',wrapper).html('varmista myymälästä').addClass('outofstock');
           $('.status__dot',wrapper).addClass('status--orange');
            $.each(products, function(sku, locations) {
                if (locations) {
                  $.each(locations, function() {
                    if (locations_map[this.location] != undefined) {
                      $('.location[data-id='+this.location+'] .instock',wrapper).removeClass('outofstock');
                      $('.location[data-id='+this.location+'] .status__dot',wrapper).removeClass('status--orange');
						var instock=parseInt(this.instock);
                        var adjustedstock=(instock - 3);
                      if (adjustedstock > 2 && adjustedstock < 11) {
                        $('.location[data-id='+this.location+'] .instock',wrapper).html(adjustedstock + ' kpl');
                        $('.location[data-id='+this.location+'] .status__dot',wrapper).addClass('status--green');
                      }
                      else if (adjustedstock > 10) {
                      	$('.location[data-id='+this.location+'] .instock',wrapper).html('10+ kpl');
                        $('.location[data-id='+this.location+'] .status__dot',wrapper).addClass('status--green');
                        
                      }
                      else{
                        $('.location[data-id='+this.location+'] .instock',wrapper).html('varmista myymälästä').addClass('outofstock');
                        $('.location[data-id='+this.location+'] .status__dot',wrapper).addClass('status--orange');
                      } 
                    }
                  });
                }          
            });
        }
      });
      
      wrapper.addClass('fetched');
    }
  });   
  
  
  // Variaation vaihdon kuuntelija
  

variant_changed($('[name="id"]', 'form.shopify-product-form').val());
  


  /**
   * Listening to addtocart button click. 
   * - Preventing add to cart event if no variant was selected.
   * - Removing alert on variant change
   */
  $('#AddToCart, .shopify-product-form button.product-item__cta').on('click', function(event) {
    if (!$(event.target).closest('form').find('[name="id"]').val()) {
      console.log('no variant')
      event.preventDefault();  

      if (!$(this).closest('form').find('.no-selected-variant').length) {
        const alert = $('<div/>')
          .addClass('no-selected-variant warning animated bounceIn')
          .html('Valitse ensin tuoteversio!')
  
        alert.insertBefore(this)
      }
    }
  });
   $('[name="id"]').on('change', function(event) {
    $(this).closest('form').find('.no-selected-variant').remove()
  });

});

   
// Variaation vaihdon kuuntelija jatkuu onLoadin jälkeen

$('form.shopify-product-form').change(function() {
  variant_changed($('[name="id"]', 'form.shopify-product-form').val());
});

function variant_changed(current_variant_id) {
  var product_form = $('form.shopify-product-form');
  if (product_form.data('previous-variant-id') != current_variant_id) {
    console.log('[Approosters] Selected Variant: ' + current_variant_id);
    
    product_form.data('current-variant-id', current_variant_id);

    product_form.trigger('approosters:variant-change');

    product_form.data('previous-variant-id', current_variant_id);
  }
} 

$('form.shopify-product-form').on('approosters:variant-change', function() {
  var form = $(this);
  $('.selected-variant-data').each(function() {
      if ($(this).data('variant-id') == form.data('current-variant-id')) {
        $(this).show();
        $(this).removeClass('hide');
      }
      else {
        $(this).hide();
        $(this).addClass('hide');
     
      }
    });
});  


/**
 * Get available inventory quantity from backend.
 *
 * @since 2021-06-15
 * @param string sku SKU of product
 * @param function handlefunction CFunction to execute after results are fetched
 */
function stock_available(sku, handlefunction) {
  if (sku) {
    $.ajax({
        url: 'https://external.unikulma.fi/WebGetBySKU/?sku=' + sku,
        type: 'get',
        success: function(response) {
            handlefunction(response);
        }
    });
  }
}

/* Refresh product page */
$('.refresh-page').on('change', function(){
    setTimeout(function(){ 
      if($('[name="option1"]').val() != "{{ value }}"){
        $('.line-item__loader-custom').removeAttr('hidden');
        location.reload();
      }
    }, 1);
});

/* Add and remove class with JQuery based on vertical scroll (Only home page) */
if ($('body').scrollTop() < 150){
 $('.sticky-index').addClass("header--transparent");
  
  /* If the header is no transparent attribute, remove the class'header--transparent' */
  var attr = $('.sticky-index').attr('transparent');
    if (typeof attr !== 'undefined' && attr !== false) {
      $('.sticky-index').addClass('header--transparent');
    }else{ 
      $('.sticky-index').removeClass('header--transparent');
   }
} 

$('body').scroll(function() {
   if ($(this).scrollTop() < 150){
      $('.sticky-index').addClass("header--transparent");
     
     /* If the header is no transparent attribute, remove the class'header--transparent' */
        var attr = $('.sticky-index').attr('transparent');
        if (typeof attr !== 'undefined' && attr !== false) {
          $('.sticky-index').addClass('header--transparent');
        }else{ 
          $('.sticky-index').removeClass('header--transparent');
        }
     
   } else {
      $('.sticky-index').removeClass("header--transparent");
    
   }
});


/* Add and remove class with JQuery based on vertical scroll (Only collection page) */
if ($('body').scrollTop() < 150){
 $('.sticky-collection').addClass("header--transparent");
}
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();    
    if (scroll >= 0.1 * $(window).height()) {
        $('.sticky-collection').removeClass("header--transparent");
    } else {
        $('.sticky-collection').addClass("header--transparent");
    }
});

/* Add and remove class with JQuery based on vertical scroll (Only page) */
if ($('body').scrollTop() < 150){
 $('.sticky-page').addClass("header--transparent");
}
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();    
    if (scroll >= 0.1 * $(window).height()) {
        $('.sticky-page').removeClass("header--transparent");
    } else {
        $('.sticky-page').addClass("header--transparent");
    }
});



/*$( ".product-tabs__tab-item-content h1, h2, h3, h4, h5, h6" ).append( "<hr />" );*/